import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const CALL = 'call';
export const EMAIL = 'email';
export const MEETING = 'meeting';
export const MILESTONE = 'milestone';
export const SHOWING = 'showing';
export const DOCUMENTATION = 'documentation';
export const OTHER = 'other';

export const CATEGORIES = {
    CALL,
    EMAIL,
    MEETING,
    MILESTONE,
    SHOWING,
    DOCUMENTATION,
    OTHER,
};

class CalendarEventCategoryAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'calendar-event-category';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'calendar-event-categories';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'isSystem',
            'name',
            'slug',
            'description',
            'organizationUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            isSystem: {
                type: 'string',
                presence: true,
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default CalendarEventCategoryAppResource;
